<div class="parallax_img vh-100" id="parallax_img" [ngStyle]="{'background-image': 'url(' + resource.image_url + ')'}"></div>

<portfolio-navigation></portfolio-navigation>

<main id="main">
    <section class="mt-5">
        <div class="container p-5 mt-5 audio-container">
            <a *ngIf="audioSources.length > 0" class="text-decoration-none mb-3 text-white" [routerLink]="['/user/resources/pods']"><i class="fa fa-chevron-left"></i> Back to Breathe Pods</a>

            <div class="text-center audio-title-container">
                <h1 class="text-white">{{ resource.file_type_title }}</h1>
            </div>

            <div class="d-flex align-items-center justify-content-center">
                <div class="player-controls" *ngIf="playButtonActive" (click)="play()"><img src="../../../../../../assets/images/icons/pod-play.png" alt=""></div>
                <div class="player-controls" *ngIf="pauseButtonActive" (click)="pause()"><img src="../../../../../../assets/images/icons/pod-pause.png" alt=""></div>
                <!-- <button class="btn btn-secondary" (click)="play()"><i class="fas fa-play"></i></button>
                <button class="btn btn-secondary" (click)="pause()"><i class="fas fa-pause"></i></button> -->
            </div>

            <div class="mt-3" *ngIf="audioSources.length > 0" plyr plyrType="audio" (plyrTimeUpdate)="timeupdate($event)" [plyrOptions]="audioOptions" [plyrPlaysInline]="true" [plyrSources]="audioSources" id="audioPlayer" (plyrInit)="audioPlayer = $event"></div>

            <div class="d-flex" *ngIf="showDuration">
                <p class="text-white mr-auto">{{ audioCurrentTimeText }}</p>
                <p class="text-white">{{ audioDurationText }}</p>
            </div>
        </div>

        <!-- Modal Loader -->
        <modal-loader [modalText]="modalText"></modal-loader>

    </section>
</main>
